import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const TempoTravellerCity = () => {
  const { cityName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [cityName]);

  const cityRoutes = {
    amritsar: [
      { destination: 'Agra', fare: 47600, route: 'amritsar-agra' },
      { destination: 'Amarnath', fare: 42000, route: 'amritsar-amarnath' },
      { destination: 'Ayodhya', fare: 84000, route: 'amritsar-ayodhya' },
      { destination: 'Badrinath Kedarnath', fare: 86800, route: 'amritsar-badrinath-kedarnath' },
      { destination: 'Char Dham', fare: 86800, route: 'amritsar-char-dham' },
      { destination: 'Dalhousie', fare: 25200, route: 'amritsar-dalhousie' },
      { destination: 'Dharamshala', fare: 30800, route: 'amritsar-dharamshala' },
      { destination: 'Govind Ghat', fare: 84000, route: 'amritsar-govind-ghat' },
      { destination: 'Jaipur', fare: 47600, route: 'amritsar-jaipur' },
      { destination: 'Jim Corbett', fare: 47600, route: 'amritsar-jim-corbett' },
      { destination: 'Kasauli', fare: 47600, route: 'amritsar-kasauli' },
      { destination: 'Kashmir', fare: 42000, route: 'amritsar-kashmir' }
    ],
    chandigarh: [
      { destination: 'Amritsar', fare: 14000, route: 'chandigarh-amritsar' },
      { destination: 'Dalhousie', fare: 33600, route: 'chandigarh-dalhousie' },
      { destination: 'Delhi Airport', fare: 14000, route: 'chandigarh-delhi-airport' },
      { destination: 'Delhi', fare: 14000, route: 'chandigarh-delhi' },
      { destination: 'Dharamshala', fare: 21000, route: 'chandigarh-dharamshala' },
      { destination: 'Kasol', fare: 22400, route: 'chandigarh-kasol' },
      { destination: 'Khatu Shyam', fare: 30800, route: 'chandigarh-khatu-shyam' },
      { destination: 'Mathura', fare: 22400, route: 'chandigarh-mathura' },
      { destination: 'Mussoorie', fare: 22400, route: 'chandigarh-mussoorie' },
      { destination: 'Salasar Balaji', fare: 30800, route: 'chandigarh-salasar-balaji' },
      { destination: 'Shimla', fare: 16800, route: 'chandigarh-shimla' },
      { destination: 'Takhat Sachkhand Sri Hazur Sahib', fare: 123200, route: 'chandigarh-takhat-sachkhand-sri-hazur-sahib' }
    ],
    delhi: [
      { destination: 'Amritsar', fare: 28000, route: 'delhi-amritsar' },
      { destination: 'Manali', fare: 33600, route: 'delhi-manali' },
      { destination: 'Shimla', fare: 25200, route: 'delhi-shimla' },
      { destination: 'Dharamshala', fare: 33600, route: 'delhi-dharamshala' },
      { destination: 'Dalhousie', fare: 39200, route: 'delhi-dalhousie' },
      { destination: 'Mussoorie', fare: 22400, route: 'delhi-mussoorie' },
      { destination: 'Himachal Pradesh', fare: 33600, route: 'delhi-himachal-pradesh' },
      { destination: 'Khatu Shyam', fare: 22400, route: 'delhi-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 19600, route: 'delhi-salasar-balaji' },
      { destination: 'Kasol', fare: 33600, route: 'delhi-kasol' },
      { destination: 'Mathura', fare: 16800, route: 'delhi-mathura' },
      { destination: 'Vrindavan', fare: 16800, route: 'delhi-vrindavan' }
    ],
    mohali: [
      { destination: 'Delhi', fare: 14000, route: 'mohali-delhi' },
      { destination: 'Delhi Airport', fare: 14000, route: 'mohali-delhi-airport' },
      { destination: 'Khatu Shyam', fare: 33600, route: 'mohali-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 33600, route: 'mohali-salasar-balaji' },
      { destination: 'Manali', fare: 33600, route: 'mohali-manali' },
      { destination: 'Himachal Pradesh', fare: 19600, route: 'mohali-himachal-pradesh' },
      { destination: 'Mussoorie', fare: 22400, route: 'mohali-mussoorie' },
      { destination: 'Shimla', fare: 10080, route: 'mohali-shimla' },
      { destination: 'Dharamshala', fare: 21000, route: 'mohali-dharamshala' },
      { destination: 'Dalhousie', fare: 25200, route: 'mohali-dalhousie' },
      { destination: 'Amritsar', fare: 15120, route: 'mohali-amritsar' },
      { destination: 'Kasol', fare: 33600, route: 'mohali-kasol' }
    ],
    patiala: [
      { destination: 'Khatu Shyam', fare: 30800, route: 'patiala-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 30800, route: 'patiala-salasar-balaji' },
      { destination: 'Amritsar', fare: 14560, route: 'patiala-amritsar' },
      { destination: 'Amritsar Sahib', fare: 14560, route: 'patiala-amritsar-sahib' },
      { destination: 'Agra', fare: 30800, route: 'patiala-agra' },
      { destination: 'Amarnath', fare: 44800, route: 'patiala-amarnath' },
      { destination: 'Ayodhya', fare: 67200, route: 'patiala-ayodhya' },
      { destination: 'Char Dham', fare: 70000, route: 'patiala-char-dham' },
      { destination: 'Badrinath Kedarnath', fare: 70000, route: 'patiala-badrinath-kedarnath' },
      { destination: 'Dalhousie', fare: 33600, route: 'patiala-dalhousie' },
      { destination: 'Dharamshala', fare: 33600, route: 'patiala-dharamshala' },
      { destination: 'Golden Temple Amritsar', fare: 15120, route: 'patiala-golden-temple-amritsar' }
    ]
  };

  const routes = cityRoutes?.[cityName?.toLowerCase()] || cityRoutes?.amritsar;
  const formattedCityName = cityName?.charAt(0)?.toUpperCase() + cityName?.slice(1)?.toLowerCase();

  const handleViewCabs = (destination, route) => {
    if (route) {
      navigate(`/tempo-traveller-booking/${route}`);
    } else {
      navigate('/tempo-traveller-details', {
        state: {
          route: {
            from: formattedCityName,
            to: destination
          }
        }
      });
    }
  };

  return (
    <>
      <SEO
        title={`Tempo Traveller From ${formattedCityName} - Book on Rent | Advait Tour and Travels`}
        description={`Book tempo traveller on rent from ${formattedCityName}. Comfortable group travel with professional drivers and well-maintained vehicles.`}
        keywords={`tempo traveller from ${cityName}, ${cityName} tempo traveller, tempo traveller on rent ${cityName}`}
        canonicalUrl={`${window.location?.origin}/tempo-traveller/${cityName}`}
        ogTitle={`Tempo Traveller From ${formattedCityName} - Book on Rent | Advait Tour and Travels`}
        ogDescription={`Book tempo traveller on rent from ${formattedCityName}. Comfortable group travel with professional drivers and well-maintained vehicles.`}
        ogUrl={`${window.location?.origin}/tempo-traveller/${cityName}`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Advait Tour and Travels",
          "description": `Tempo Traveller rental service from ${formattedCityName}`
        }}
      />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Tempo Traveller From {formattedCityName}
              </h1>
            </div>
          </div>

          {/* Route Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
              {routes?.map((route, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6"
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
                    {formattedCityName} To {route?.destination}
                  </h3>
                  <p className="text-gray-600 text-center mb-4">
                    Fare Starts ₹{route?.fare?.toLocaleString('en-IN')}/-
                  </p>
                  <button
                    onClick={() => handleViewCabs(route?.destination, route?.route)}
                    className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors duration-300"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Visitor's Guide Content */}
          <div className="container mx-auto px-4 mb-16">
            <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-orange-500 mb-6 text-center">
                Visitor's Guide
              </h2>
              
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <h3 className="text-2xl font-bold text-gray-800">
                  Book Tempo Traveller on Rent in {formattedCityName} – Explore Comfortably with Advait Tour and Travels
                </h3>
                
                <p>
                  When it comes to traveling with family or a group of friends, comfort and convenience become a priority. At Advait Tour and Travels, we understand your need for a seamless travel experience. That's why we offer Tempo Traveller on rent in {formattedCityName}, providing a comfortable and spacious vehicle for your journeys.
                </p>

                <p>
                  Whether you're planning a weekend getaway, a sightseeing trip around the region, or a long-distance journey, Advait Tour and Travels ensures a smooth ride every time. With us, you can hire a Tempo Traveller in {formattedCityName} that perfectly fits your travel needs.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Why Choose Advait Tour and Travels for Tempo Traveller Rentals?
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">1. Comfort and Space</h4>
                    <p>Our Tempo Travellers in {formattedCityName} are designed to offer maximum comfort, regardless of the distance you are traveling. With spacious interiors, ample legroom, and reclining seats, your journey will be relaxing and enjoyable. Whether you're traveling with a group of 10, 12, or even 15 people, our vehicles can comfortably accommodate your entire party.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">2. Well-Maintained Vehicles</h4>
                    <p>We take pride in maintaining our fleet to the highest standards. Every Tempo Traveller in {formattedCityName} undergoes regular checks and servicing to ensure safety and reliability. From clean interiors to well-functioning air conditioning, you'll find every aspect of the vehicle in top condition, making your trip worry-free.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">3. Experienced and Professional Drivers</h4>
                    <p>Our Tempo Traveller rental service comes with experienced drivers who are well-versed with the local routes and tourist spots. Our drivers are not only professional but also courteous, ensuring a pleasant and safe travel experience. They prioritize your safety and comfort while providing a hassle-free journey through the scenic routes around {formattedCityName}.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">4. Affordable Tempo Traveller in {formattedCityName}</h4>
                    <p>We believe in offering value for money, which is why our pricing is competitive and transparent. When you book a Tempo Traveller on rent in {formattedCityName} with Advait Tour and Travels, you can rest assured that there are no hidden charges. Whether you're traveling locally or for long distances, our services are designed to be budget-friendly without compromising on quality or comfort.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">5. Customizable Travel Plans</h4>
                    <p>At Advait Tour and Travels, we understand that every trip is unique. That's why we offer tempo traveller rental in {formattedCityName} with flexible travel plans. Whether you need the vehicle for a few hours, a day, or an extended period, we can customize the rental package to suit your itinerary.</p>
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Types of Tempo Travellers Available for Rent
                </h3>
                
                <p>
                  At Advait Tour and Travels, we offer various types of Tempo Travellers for hire in {formattedCityName}, ensuring that you can choose the one that best meets your group's needs:
                </p>

                <div className="space-y-3">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">1. 9-Seater Tempo Traveller</h4>
                    <p>Perfect for small groups, the 9-seater Tempo Traveller is compact yet spacious, ensuring a comfortable journey.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">2. 12-Seater Tempo Traveller</h4>
                    <p>Ideal for medium-sized groups, the 12-seater offers more space while still being nimble enough for city travel and long-distance journeys.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">3. 15-Seater Tempo Traveller</h4>
                    <p>For larger groups, the 15-seater Tempo Traveller is the ideal option. With ample legroom and luggage space, it guarantees comfort over long trips.</p>
                  </div>
                </div>

                <p className="mt-4">
                  All our vehicles come equipped with air conditioning, plush seating, and ample space for luggage, ensuring that your journey is as comfortable as possible.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Popular Routes for Tempo Traveller Hire in {formattedCityName}
                </h3>
                
                <p>
                  Here are some of the popular routes for which customers often choose to hire Tempo Travellers in {formattedCityName}:
                </p>

                <div className="space-y-3">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">1. {formattedCityName} to Shimla</h4>
                    <p>A scenic drive through the hills, the journey to Shimla is made even better with the comfort of a Tempo Traveller. Our vehicles provide the space and comfort needed for a trip through winding mountain roads.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">2. {formattedCityName} to Manali</h4>
                    <p>A longer journey, but worth every minute when you're traveling in a spacious Tempo Traveller. Explore the beauty of Himachal Pradesh in style and comfort.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">3. {formattedCityName} to Amritsar</h4>
                    <p>Visit the Golden Temple or explore the historic city of Amritsar with ease. Hire a Tempo Traveller in {formattedCityName} for a smooth and comfortable ride for your entire group.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">4. Contact Us</h4>
                    <p>Give us a call or visit our website to discuss your travel plans. Let us know the size of your group, the duration of your trip, and any specific needs you may have.</p>
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Choose Your Tempo Traveller
                </h3>
                
                <p>
                  Based on your group size and preferences, we'll recommend the best-suited vehicle from our fleet. You can choose between a 9, 12, or 15-seater Tempo Traveller.
                </p>

                <div className="space-y-3 mt-4">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">1. Get a Quote</h4>
                    <p>We provide a clear and transparent quote based on your travel requirements. Rest assured, there are no hidden fees or additional charges when you book with us.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">2. Confirm Your Booking</h4>
                    <p>Once you're satisfied with the vehicle and the pricing, confirm your booking, and you're all set! Our team will coordinate with you to ensure a seamless pickup and drop-off experience.</p>
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Affordable Tempo Traveller in {formattedCityName} – Why Advait Tour and Travels?
                </h3>
                
                <p>
                  Traveling in a group has never been easier. At Advait Tour and Travels, we pride ourselves on providing an affordable and reliable Tempo Traveller rental service in {formattedCityName}. Whether it's a short trip or an extended journey, we offer the perfect blend of comfort, convenience, and cost-effectiveness. Here's why choosing us makes sense:
                </p>

                <ul className="space-y-2 list-disc list-inside mt-4">
                  <li><strong>Affordable Pricing:</strong> Our pricing structure is designed to fit all budgets, offering the best value for money.</li>
                  <li><strong>Flexible Rental Plans:</strong> Whether you need the vehicle for a day or a week, we offer rental plans that suit your schedule.</li>
                  <li><strong>Wide Range of Vehicles:</strong> Choose from our fleet of well-maintained Tempo Travellers, each equipped with modern amenities.</li>
                  <li><strong>24/7 Customer Support:</strong> Our team is always available to assist with your travel needs, ensuring a smooth and hassle-free experience.</li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Plan Your Trip Today – Hire Tempo Traveller in {formattedCityName}
                </h3>
                
                <p>
                  If you're planning a group trip and looking for a reliable and affordable Tempo Traveller in {formattedCityName}, look no further than Advait Tour and Travels. With our comfortable vehicles, experienced drivers, and excellent customer service, we ensure that your journey is both enjoyable and stress-free. From family vacations to corporate outings, our Tempo Traveller rental service in {formattedCityName} caters to all your travel needs.
                </p>

                <p className="mt-4">
                  Don't let the stress of group travel hold you back. Book your Tempo Traveller on rent in {formattedCityName} with Advait Tour and Travels today and experience the perfect blend of comfort, convenience, and affordability.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  FAQs
                </h3>
                
                <div className="space-y-4 mt-4">
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">1. How many seats in Tempo Traveller?</h4>
                    <p>We offer Tempo Travellers with various seating capacities: 12-seater, 17-seater, and 25-seater options. Force Urbania is available with 16 seats.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">2. Can I book a Tempo Traveller for a single day?</h4>
                    <p>Yes, absolutely! We offer flexible booking options including single day packages.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">3. Are Tempo Travellers available for outstation?</h4>
                    <p>Yes, our Tempo Travellers are specifically designed for outstation trips covering all major destinations.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">4. Does the Tempo Traveller have AC?</h4>
                    <p>Yes, all our Tempo Travellers come equipped with air conditioning.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">5. What are the amenities in Tempo Traveller?</h4>
                    <p>Our Tempo Travellers include: Air conditioning, comfortable push-back seats, ample luggage space, music system, charging points, first aid kit, and experienced drivers.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">6. How to book a Tempo Traveller?</h4>
                    <p>Booking is simple! Call us at +91-7998666660 or WhatsApp for instant booking assistance.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">7. Will I get a driver with a Tempo Traveller?</h4>
                    <p>Yes, all Tempo Traveller bookings include an experienced and verified driver.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">8. What is the cancellation policy for a Tempo Traveller?</h4>
                    <p>Free cancellation up to 48 hours before scheduled departure. Cancellations within 48-24 hours incur 25% charge.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">9. Is there a mileage limit on Tempo Traveller rentals?</h4>
                    <p>Our packages include specific mileage based on the route. Extra kilometers are charged at nominal rates.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">10. Is there a special package for long term rental service?</h4>
                    <p>Yes, we offer attractive long-term rental packages. Contact our team at +91-7998666660 for customized quotes.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">11. Are these Tempo Travellers well maintained?</h4>
                    <p>Absolutely! All our Tempo Travellers undergo regular maintenance checks and thorough cleaning before every trip.</p>
                  </div>
                  
                  <div>
                    <h4 className="text-lg font-bold text-gray-800">12. Can I use Tempo Traveller for airport transfers?</h4>
                    <p>Yes, our Tempo Travellers are perfect for group airport transfers with timely pickup and drop services.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-7998666660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TempoTravellerCity;